export default [
    {
        "isRequestSuccessful": true,
        "responseMessage": "",
        "backgroundColour": "#dee2e6",
        "textColour": "#000000" 
    }
]